module.exports = __webpack_public_path__ + "static/media/BTM.4aa48dd5.svg";